import { IconButton, Link } from '@mui/material'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid'
import { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DeleteIcon } from 'src/shared/icons/Icons'
import styled from 'styled-components'

const DataGridStyled = styled(DataGrid)`
  & .MuiDataGrid-row {
    &:hover {
      cursor: pointer;
    }
  }
`

export const OrganizationGrid = ({ organizations, onDeleteOrganization }) => {
  const navigate = useNavigate()
  const apiRef = useGridApiRef()
  const [page, setPage] = useState(25)

  const onDelete = useCallback(
    (event, conferenceId) => {
      onDeleteOrganization(conferenceId)
      event.stopPropagation()
    },
    [onDeleteOrganization]
  )

  const columns = useMemo(() => {
    return [
      {
        field: 'id',
        headerName: 'ID',
        flex: 0.2
      },
      {
        field: 'name',
        headerName: 'Organization Name',
        flex: 1
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 1
      },
      {
        field: 'website',
        headerName: 'Website',
        flex: 1,
        renderCell: (params) => (
          <Link href={params.row.website} target='_blank'>
            {params.row.website}
          </Link>
        )
      },
      {
        field: 'phone_number',
        headerName: 'Phone number',
        flex: 1
      },
      {
        field: 'action',
        headerName: 'Action',
        flex: 1,
        sortable: false,
        renderCell: ({ value }) => (
          <>
            <IconButton onClick={(event) => onDelete(event, value)} color='secondary' sx={{ marginRight: 1 }}>
              <DeleteIcon />
            </IconButton>
          </>
        )
      }
    ]
  }, [onDelete])

  const rows = useMemo(() => {
    return organizations.map((organization) => ({
      ...organization,
      action: organization.id
    }))
  }, [organizations])

  const onRowClick = ({ row }) => {
    if (row.id) {
      navigate(`/organizations/edit/${row.id}`)
    }
  }

  return (
    <DataGridStyled
      ref={apiRef}
      columns={columns}
      rows={rows}
      pageSize={page}
      onPageSizeChange={(newPageSize) => setPage(newPageSize)}
      rowsPerPageOptions={[25, 50, 100]}
      disableSelectionOnClick
      disableColumnSelector
      disableColumnReorder
      disableColumnPinning
      disableColumnMenu
      disableColumnFilter
      onRowClick={(props) => onRowClick(props)}
      autoHeight
    />
  )
}
